import { GET_REGISTRATION_ORGANISATIONS_LIST_URL } from '../../constants/apiUrls';
import { GET_ORGANISATION_UUID_LIST_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { KeyValueResponse } from '../typings';

export const useGetOrganisationUuidList = () => {
  const getOrganisationUuidList = async () => {
    const res = await axiosClient.get<KeyValueResponse[]>(GET_REGISTRATION_ORGANISATIONS_LIST_URL);

    return res.data;
  };

  return useCustomQuery(
    GET_ORGANISATION_UUID_LIST_QUERY_KEY,
    getOrganisationUuidList,
    {
      staleTime: Infinity,
    },
    false
  );
};
